var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassingline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 116.355,
    height: 19.161,
    viewBox: "0 0 116.355 19.161",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15632",
    "data-name": "Path 15632",
    d: "M7863.375-5869.16l18.307-18.307h97.695",
    transform: "translate(-7863.021 5887.967)",
    fill: "none",
    stroke: "#dbdbdb",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassingline);
export default __webpack_public_path__ + "static/media/passingline.83a73453f79f65fdc2cdcbecc482878c.svg";
export { ForwardRef as ReactComponent };